import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    root: {
        display: 'grid',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    input: {
        flex: 1,
        margin: theme.spacing(1)
    },
    row: {
        display: 'flex',
        alignItems: 'center',
    },
    switch: {
        margin: theme.spacing(1, 2)
    },
    textarea: {
        display: 'grid',
        gap: theme.spacing(1)
    },
    paper: {
        display: 'block',
        justifyContent: 'center',
        padding: theme.spacing(2),
        width: '100%'
    },
    rootFab: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        }
    },
    container: {
        display: 'flex',
        justifyContent: "flex-end",
    },
    modal: {
        display: 'flex',
        flexDirection: 'column',
    },
    buttons: {
        alignSelf: 'flex-end',
        justifyContent: 'space-between',
    },
    button: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1)
    },
    [theme.breakpoints.up('md')]: {
        root: {
            gridTemplateColumns: '1fr 1fr'
        }
    },
    buttonPerception: {
        padding: '0px'
    },
    itemPerception: {
        width: '100%'
    },
    descriptionPerception: {
        marginLeft: '2rem'
    },

    changeButton:{
        marginTop: '2rem',
        textAlign: 'right'
    }
}));